import { FormattedMessage } from 'react-intl';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { paperClasses } from '@mui/material/Paper';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useTheme } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { LoadingButton, Button } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';

type terminateDialogProps = Omit<DialogProps, 'onSubmit'> & {
  onSubmit?: () => void;
  loading?: boolean;
};
export function ConfirmAssignOfEntireRecurrenceDialog({ sx, onSubmit, loading, ...props }: terminateDialogProps) {
  const theme = useTheme();

  const localizationSubset = 'shifts.confirmAssignOfEntireRecurrenceDialog';

  const handleClose = () => {
    props.onClose?.({}, 'escapeKeyDown');
  };

  return (
    <Dialog
      fullWidth
      maxWidth={'xs'}
      sx={{
        [`& .${paperClasses.root}`]: {
          bgcolor: `color-mix(in srgb, #fff 100%, ${theme.palette.primary.main} 8%)`,
        },
        ...sx,
      }}
      {...props}
    >
      <DialogTitle sx={{ px: 3, pt: 4, pb: 2 }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" gap={1}>
            <Typography variant="h5">
              <FormattedMessage id={`${localizationSubset}.title`} />
            </Typography>
            <Typography variant="body1" color="text.secondary">
              <FormattedMessage id={`${localizationSubset}.subtitle`} />
            </Typography>
          </Stack>
          <Box>
            <IconButton sx={{ width: '40px', position: 'relative', top: -5, right: -5 }} onClick={handleClose}>
              <FaIcon name="xmark" variant="light" />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack gap={2}>
          <Typography variant="body1">
            <FormattedMessage id={`${localizationSubset}.body`} />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 0 }}>
        <Box color="text.secondary">
          <Button variant="text" color="inherit" rounded onClick={handleClose} size="large">
            <FormattedMessage id="common.cancel" />
          </Button>
        </Box>
        <LoadingButton
          loading={loading}
          variant="contained"
          color="warning"
          rounded
          onClick={() => onSubmit?.()}
          size="large"
        >
          {/* <FormattedMessage id="common.submit" /> */} Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
